import { Checkbox } from "@/components/ui/checkbox";
import {
  TENANT_APP_USER_ROLE_DEFINITIONS,
  type TenantAppUserRoleKey,
} from "../../../../../packages/shared-types/src/tenant-app-user-roles.js";

export function TenantAppUserRolePicker({
  value,
  onChange,
}: {
  value: TenantAppUserRoleKey[];
  onChange: (value: TenantAppUserRoleKey[]) => void;
}) {
  return (
    <div className="flex flex-col gap-2">
      {TENANT_APP_USER_ROLE_DEFINITIONS.map((role) => {
        const checked = value.includes(role.key);
        return (
          <label
            key={role.key}
            className="flex items-start gap-3 rounded-md border border-border px-3 py-2 cursor-pointer"
            style={{ background: checked ? "var(--bg-accent)" : "var(--bg-elevated)" }}
          >
            <Checkbox
              checked={checked}
              onCheckedChange={() => onChange(toggleTenantAppUserRole(value, role.key))}
              className="mt-0.5"
            />
            <span className="flex flex-col gap-0.5">
              <span className="text-sm font-medium" style={{ color: "var(--text-strong)" }}>
                {role.label}
              </span>
              <span className="text-xs" style={{ color: "var(--muted-foreground)" }}>
                {role.description}
              </span>
            </span>
          </label>
        );
      })}
    </div>
  );
}

function toggleTenantAppUserRole(
  values: TenantAppUserRoleKey[],
  roleKey: TenantAppUserRoleKey,
): TenantAppUserRoleKey[] {
  return values.includes(roleKey)
    ? values.filter((value) => value !== roleKey)
    : [...values, roleKey].toSorted();
}